import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { startClarity } from './utils/clarity';
import './styles/responsive.css';
import './styles/darkMode.css';
import { initTheme } from './utils/theme';
import { settleStoredSession, startSessionWatch } from './utils/session';

// The loader checks production, project configuration, and stored opt-in.
startClarity();
initTheme();
// A sign-in that ran out while the site was closed goes to the login page,
// not to a page of failed requests (utils/session.js).
settleStoredSession();
startSessionWatch();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
